import React, { useMemo } from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';

interface FilterOption {
  id: any;
  label: string;
}

interface FilterCategoryMultiSelectProps {
  label: string;
  placeholder: string;
  noOptionsText: string;
  items: any[];
  selectedValues: any[];
  onChange: (values: any[]) => void;
  chipStyleVariant?: 'default' | 'filter' | 'filter-panel';
}

const FilterCategoryMultiSelect: React.FC<FilterCategoryMultiSelectProps> = ({
  label,
  placeholder,
  noOptionsText,
  items,
  selectedValues,
  onChange,
  chipStyleVariant = 'default',
}) => {
  const options = useMemo<FilterOption[]>(() => {
    return (items || [])
      .filter((item) => item && item.id !== undefined && item.id !== null)
      .map((item) => ({
        id: item.id,
        label: item.name || item.displayName || String(item.id),
      }));
  }, [items]);

  const selectedOptions = useMemo<FilterOption[]>(() => {
    return options.filter((option) => (selectedValues || []).includes(option.id));
  }, [options, selectedValues]);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <>
      <Autocomplete
        multiple
        options={options}
        value={selectedOptions}
        onChange={(_event, value) => onChange(value.map((option) => option.id))}
        disableCloseOnSelect
        noOptionsText={noOptionsText}
        loadingText="Laden..."
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
                <Chip
                  variant="filled"
                  label={option.label}
                  {...getTagProps({ index })}
                  key={option.id}
                  sx={chipStyleVariant === 'filter' ? {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    color: '#fff',
                    '& .MuiChip-deleteIcon': {
                      color: 'rgba(255, 255, 255, 0.9)',
                    },
                    '& .MuiChip-deleteIcon:hover': {
                      color: '#fff',
                    },
                  } : chipStyleVariant === 'filter-panel' ? {
                    backgroundColor: '#2d3f58',
                    color: '#fff',
                    fontWeight: 500,
                    '& .MuiChip-deleteIcon': {
                      color: 'rgba(255, 255, 255, 0.8)',
                    },
                    '& .MuiChip-deleteIcon:hover': {
                      color: '#fff',
                    },
                  } : undefined}
                />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="filled"
            placeholder={placeholder}
          />
        )}
      />
    </>
  );
};

export default FilterCategoryMultiSelect;
